import React from "react";

const DEShadow = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="231" height="241" fill="none">
            <g filter="url(#a)">
                <ellipse cx="108.578" cy="113.38" rx="38.444" ry="43.074" fill="#D297A0" />
            </g>
            <g opacity=".5" filter="url(#b)">
                <ellipse cx="115.51" cy="120.493" rx="37.5" ry="41.917" fill="#EC6F29" />
            </g>
            <path
                opacity=".75"
                d="M80.588 61.117a.007.007 0 0 0-.007-.007 7.197 7.197 0 0 1-6.87-6.87.007.007 0 0 0-.007-.007.007.007 0 0 0-.006.006 7.197 7.197 0 0 1-6.87 6.87.007.007 0 0 0 0 .014 7.197 7.197 0 0 1 6.87 6.87c0 .004.003.007.006.007a.007.007 0 0 0 .007-.006 7.197 7.197 0 0 1 6.87-6.87.007.007 0 0 0 .007-.008Z"
                fill="url(#c)"
            />
            <g opacity=".88">
                <path
                    d="M160.82 62.405c0-.002-.001-.004-.004-.004a4.606 4.606 0 0 1-4.397-4.397c0-.002-.001-.004-.004-.004a.004.004 0 0 0-.004.004 4.606 4.606 0 0 1-4.397 4.397.004.004 0 0 0-.004.004c0 .003.002.005.004.005a4.606 4.606 0 0 1 4.397 4.397c0 .002.002.004.004.004.003 0 .004-.002.004-.004a4.606 4.606 0 0 1 4.397-4.397c.003 0 .004-.002.004-.005Z"
                    fill="#FFEEE5"
                />
                <path
                    d="M160.82 62.405c0-.002-.001-.004-.004-.004a4.606 4.606 0 0 1-4.397-4.397c0-.002-.001-.004-.004-.004a.004.004 0 0 0-.004.004 4.606 4.606 0 0 1-4.397 4.397.004.004 0 0 0-.004.004c0 .003.002.005.004.005a4.606 4.606 0 0 1 4.397 4.397c0 .002.002.004.004.004.003 0 .004-.002.004-.004a4.606 4.606 0 0 1 4.397-4.397c.003 0 .004-.002.004-.005Z"
                    fill="url(#d)"
                />
            </g>
            <g opacity=".5">
                <path
                    d="M101.395 42.693c0-.003-.002-.005-.005-.005a4.906 4.906 0 0 1-4.683-4.684.005.005 0 0 0-.004-.004.004.004 0 0 0-.005.004 4.906 4.906 0 0 1-4.684 4.684.005.005 0 0 0-.004.005c0 .002.002.004.004.004a4.906 4.906 0 0 1 4.684 4.684c0 .002.002.004.005.004a.005.005 0 0 0 .004-.004 4.906 4.906 0 0 1 4.683-4.684c.003 0 .005-.002.005-.004Z"
                    fill="#FFEEE5"
                />
                <path
                    d="M101.395 42.693c0-.003-.002-.005-.005-.005a4.906 4.906 0 0 1-4.683-4.684.005.005 0 0 0-.004-.004.004.004 0 0 0-.005.004 4.906 4.906 0 0 1-4.684 4.684.005.005 0 0 0-.004.005c0 .002.002.004.004.004a4.906 4.906 0 0 1 4.684 4.684c0 .002.002.004.005.004a.005.005 0 0 0 .004-.004 4.906 4.906 0 0 1 4.683-4.684c.003 0 .005-.002.005-.004Z"
                    fill="url(#e)"
                />
            </g>
            <defs>
                <linearGradient id="c" x1="73.704" y1="54.233" x2="79.088" y2="66.842" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFEEE5" />
                    <stop offset="1" stopColor="#ECBEBB" />
                </linearGradient>
                <linearGradient id="d" x1="156.415" y1="58" x2="159.861" y2="66.069" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFEEE5" />
                    <stop offset="1" stopColor="#ECBEBB" />
                </linearGradient>
                <linearGradient id="e" x1="96.702" y1="38" x2="100.372" y2="46.596" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFEEE5" />
                    <stop offset="1" stopColor="#ECBEBB" />
                </linearGradient>
                <filter
                    id="a"
                    x="13.555"
                    y="13.728"
                    width="190.046"
                    height="199.304"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="28.289" result="effect1_foregroundBlur_7_50" />
                </filter>
                <filter
                    id="b"
                    x=".01"
                    y=".576"
                    width="231"
                    height="239.833"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="39" result="effect1_foregroundBlur_7_50" />
                </filter>
            </defs>
        </svg>
    );
};

export default DEShadow;
